<script>
// Importing Line class from the vue-chartjs wrapper
import { Bar, mixins } from 'vue-chartjs'

// Import Javascript libraries
import moment from 'moment'

export default {
  props: {
    chartData: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  },
  extends: Bar,
  mixins: [mixins.reactiveProp],

  data () {
    return {
      data: {
        // Data to be represented on x-axis
        labels: this.chartData.labels,
        datasets: [{
          label: 'Total votes',
          data: this.chartData.votes,
          backgroundColor: 'rgba(233, 30, 99, 0.2)',
          borderColor: 'rgba(233, 30, 99, 0.8)',
          borderWidth: 1,
          maxBarThickness: 40
        }]
      },
      // Chart.js options that controls the appearance of the chart
      options: {
        scales: {
          offset: false,
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    // renderChart function renders the chart with the datacollection and options object.
    this.renderChart(this.data, this.options)
  },
  methods: {
    dayFullName (date) {
      const getFullName = moment(date).format('dddd')
      return getFullName // Monday, Tuesday etcetera
    }
  }
}
</script>
